export var getTranslation = function (intl, key, values) {
    return intl.formatMessage({ id: "leaderboard.".concat(key) }, values);
};
